import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=1dd02c64&"
import script from "./domain.vue?vue&type=script&lang=js&"
export * from "./domain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports